import api from './api';

export function findAll() {
  return api.get('/alergias');
}

export function save(values) {
  return api.post('/alergias', values);
}
